import { createAction, props } from '@ngrx/store';
import { Event } from '../../models';

export const LoadRelatedEvents = createAction('[Events] Load Related Events', props<{ eventId: number }>());
export const LoadRelatedEventsSuccess = createAction('[Events] Load Related Events Success', props<{ events: Event[] }>());
export const LoadRelatedEventsFail = createAction('[Events] Load Related Events Fail', props<{ error: any }>());
